import React from 'react';
import { Switch, Route, Redirect } from "react-router-dom";
import Accueil from "./components/accueil/Accueil";
import DisplayBureau from "./components/bureau/DisplayBureau";
import './components/grille.css';
import LoginPage from './components/login/Login';
import AdminPage from './components/login/AdminUsers';
import Devis from './components/email/Devis';
import Upload from './components/upload/UploadFile';
import Recrutement from './components/email/Recrutement';
import Mentions from './components/mentions/mentions';
import DisplayActualites from "./components/actualites/DisplayActualites";
import DisplayPartenaires from "./components/partenaires/DisplayPartenaires";
import Contact from "./components/email/Contact";
import DisplayApropos from "./components/apropos/DisplayApropos";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLogged: false,
      redirectToAdminPage: false,
      redirectToUpload: false
    };
  }

  // fonction pour mettre à jour isLogged et redirectToAdminPage dans le state de App.js,
  // cette fonction est passée en props au composant LoginPage pour que ce même composant puisse déclencher cette fonction
  updateLogin = () => {
    this.setState({
      isLogged: true,
      redirectToAdminPage: true
    });
  };

  redirectUpload = () => {
    this.setState({
      isLogged: true,
      redirectToUpload: true
    });
  }

  render() {
    const { isLogged, redirectToAdminPage, redirectToUpload } = this.state;
    return (
      <>
        {redirectToAdminPage && <Redirect to="/admin" />}
        {redirectToUpload && <Redirect to="/admin/upload" />}
        <Switch>
          <Route exact path="/" component={Accueil} />
          <Route exact path="/devis" component={Devis} />
          <Route exact path="/recrutement" component={Recrutement} />
          <Route exact path="/bureau" component={DisplayBureau} />
          <Route exact path="/actualites" component={DisplayActualites} />
          <Route exact path="/partenaires" component={DisplayPartenaires} />
          <Route exact path="/contact" component={Contact} />
          <Route exact path="/mentions" component={Mentions} />
          <Route exact path="/apropos" component={DisplayApropos} />
          <Route exact path="/login" component={() => <LoginPage updateFunction={this.updateLogin} />} />
          {isLogged ? <Route exact path="/admin" component={() => <AdminPage redirectUpload={this.redirectUpload} />}  /> : <Redirect to="/" />}
          {isLogged ? <Route exact path="/admin/upload" component={Upload} /> : <Redirect to="/" />}
        </Switch>
      </>
    )
  }
}

export default App;
